import React, { useState } from 'react';
import * as bcrypt from 'bcryptjs';
import { Input } from '../Input';
import { Button } from '../../subkit-ui';
import { Information } from '../Information';
import { validateEmail } from '../../utils/helpers';
import { superUserEmailHashes } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var LoginForm = function LoginForm(_ref) {
  var loading = _ref.loading,
      classes = _ref.classes,
      login = _ref.login,
      showSignUpLink = _ref.showSignUpLink,
      onSignUpLinkClick = _ref.onSignUpLinkClick;

  var _useState = useState(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(false),
      isSuper = _useState2[0],
      setIsSuper = _useState2[1];

  var _useState3 = useState(''),
      impersonateEmail = _useState3[0],
      setImpersonateEmail = _useState3[1];

  var btnDisabled = loading ? true : !validateEmail(email);

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();

    if (isSuper && impersonateEmail) {
      login(email, impersonateEmail);
      return;
    }

    var superUser = false;
    superUserEmailHashes.forEach(function (hash) {
      if (bcrypt.compareSync(email, hash)) {
        superUser = true;
      }
    });

    if (!superUser) {
      login(email);
      return;
    }

    setImpersonateEmail(email);
    setIsSuper(true);
  };

  return /*#__PURE__*/_jsxs("form", {
    className: "flex flex-column mb2 prospect-form ".concat(classes),
    onSubmit: handleSubmit,
    autoComplete: "new-password",
    "data-cy": "LoginForm",
    children: [/*#__PURE__*/_jsx(Information, {
      classes: {
        container: 'mb2'
      },
      heading: "Welcome back. \n Let's do this."
    }), /*#__PURE__*/_jsx(Input, {
      format: "rounded",
      label: "Email address",
      inputType: "email",
      classes: {
        input: 'w-fill'
      },
      name: "email",
      onInputChange: function onInputChange(_, v) {
        return setEmail("".concat(v));
      }
    }), isSuper && /*#__PURE__*/_jsx(Input, {
      format: "rounded",
      label: "Log in as email address",
      inputType: "email",
      classes: {
        input: 'w-fill',
        container: 'my-4'
      },
      name: "impersonateEmail",
      inputValue: impersonateEmail,
      onInputChange: function onInputChange(_, v) {
        return setImpersonateEmail("".concat(v));
      },
      hasFocus: isSuper
    }), /*#__PURE__*/_jsx(Button, {
      text: "Login",
      classes: "mt-3 w-1/3",
      disabled: btnDisabled,
      buttonType: "submit"
    }), showSignUpLink && /*#__PURE__*/_jsxs("div", {
      className: "col-12 mt3",
      children: ["Don\u2019t have a Subkit account?", ' ', /*#__PURE__*/_jsx("span", {
        className: "clickable p1 c-dark-green fw-600",
        onClick: onSignUpLinkClick,
        children: "Sign up"
      })]
    })]
  });
};